






























































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import { validateCNPJ, validateEmail, getUfs, validateGUID, generateGUID } from '@/utils/common'
import SuporteHospitaisRemuneracaoStore from '../store/SuporteHospitaisRemuneracaoStore'

@Component
export default class ModalRemuneracaoSuporteHospital extends Vue {
  $refs!: {
    formNovoHospital: any,
    imageUpload: any,
  }

  loadSaveOrUpdateHospital: boolean = false

  get getSuporteHospitaisRemuneracaoStore() { return getModule(SuporteHospitaisRemuneracaoStore, this.$store) }

  get loadingSaveOrUpdateHospital() { return this.loadSaveOrUpdateHospital }
  set loadingSaveOrUpdateHospital(value: boolean) { this.loadSaveOrUpdateHospital = value }

  get showModalHospital() { return this.getSuporteHospitaisRemuneracaoStore.modal.criarHospital }
  set showModalHospital(value: boolean) { this.getSuporteHospitaisRemuneracaoStore.setModal({ name: 'criarHospital', value }) }

  get ultimaSituacaoFluxoNF() {
    return [
      { key: 'EnviadoParaPagamento', display: 'Enviado para pagamento' },
      { key: 'Validada', display: 'Validada' },
    ]
  }

  get cargaRepasseStatusInicial() {
    return [
      { key: 'Gerado', display: 'Gerado' },
      { key: 'Liberado', display: 'Liberado' },
    ]
  }

  formNovoHospitalRules: any = {
    valid: true,
    nome: [(v: any) => !!v || 'Campo obrigatório'],
    cnpj: [(v: any) => this.validateCnpj(v)],
    codigoHis: [(v: any) => !!v || 'Campo obrigatório'],
    ultimaSituacaoFluxoNF: [(v: any) => !!v || 'Campo obrigatório'],
  }

  validateCnpj(value) {
    if (['', null, undefined].includes(value)) return 'Campo obrigatório.'
    const cleanedValue = value.replace(/\./g, '').replace(/-/g, '').replace(/\//g, '')
    if (cleanedValue.length < 14) return 'CNPJ inválido.'
    if (cleanedValue.length === 14) return validateCNPJ(cleanedValue) || 'CNPJ inválido.'
    return false
  }

  keyToUpperCase(event: KeyboardEvent) {
    return String(event.key).toUpperCase()
  }

  async saveOrUpdateHospital() {
    this.loadingSaveOrUpdateHospital = true

    if (this.$refs.formNovoHospital.validate()) {
      const { mode } = this.getSuporteHospitaisRemuneracaoStore

      let response: any
      if (mode === 'CREATE') {
        this.getSuporteHospitaisRemuneracaoStore.setNovoHospital()
        response = await this.getSuporteHospitaisRemuneracaoStore.criarHospital()
      } else {
        response = await this.getSuporteHospitaisRemuneracaoStore.atualizarHospital()
      }

      if (response.success) {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Hospital ${mode === 'CREATE' ? 'criado' : 'alterado'} com sucesso!`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.getSuporteHospitaisRemuneracaoStore.getHospitaisPorGrupo(this.getSuporteHospitaisRemuneracaoStore.hospitalId)
        this.showModalHospital = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: response.message || `Ocorreu um erro ao ${mode === 'CREATE' ? 'criar' : 'alterar'} o hospital`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingSaveOrUpdateHospital = false
  }

  @Watch('showModalHospital')
  async onChangeShowModalHospital(value: boolean) {
    if (!value) {
      this.$refs.formNovoHospital.resetValidation()
      this.$refs.formNovoHospital.reset()
      this.$refs.imageUpload.clear()
      this.$refs.imageUpload.errors = []
      this.getSuporteHospitaisRemuneracaoStore.clearHospitalDetails()
      this.getSuporteHospitaisRemuneracaoStore.clearNovoHospital()
      this.getSuporteHospitaisRemuneracaoStore.setMode({ mode: '' })
    }
  }
}
